import React, { useState, useEffect } from 'react';

import MaterialTable from "material-table";

import { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

import { appConfig } from '../config.js';


const KpiDataGrid = ({ networkName, selectedCells, fromDate, toDate, token }) => {

    function dateToString(inDate) {
        let dateUTC = new Date(Date.UTC(inDate.getFullYear(), inDate.getMonth(), inDate.getDate()));
        let strDate = dateUTC.toISOString().slice(0, 10);
        return strDate;
    }

    const [data, setData] = useState([])

    const baseURL = appConfig.api.URL;
    const strFromDate = dateToString(fromDate);
    const strToDate = dateToString(toDate);

    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
    };

    useEffect(() => {
        let url = `${baseURL}/kpis/?date=${strFromDate}`;
        if (fromDate !== null) {
            url = `${baseURL}/kpis/?date=${strFromDate}`;
            if (toDate != null) {
                url = `${baseURL}/kpis/?network=${networkName}&from_date=${strFromDate}&to_date=${strToDate}`;
            }
        }
        if (selectedCells){
            url = `${url}&device_names=${selectedCells.join(',')}`;
        }

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Token ${token}`
            }
        })
            .then(results => results.json())
            .then(data => {
                setData(data);
            }
            )

    }, [networkName, selectedCells, fromDate, toDate])

    return (
        <>
            <MaterialTable
                title=""
                icons={tableIcons}
                options={{
                    headerStyle: {
                        backgroundColor: 'lightgray',
                        fontWeight: 'bold',
                        color: 'black',
                    },
                    // fixedColumns: {
                    //   left: 3, 
                    //   right: 0
                    // }
                }}
                columns={[
                    { title: "Device Name", field: "device_name" },
                    { title: "Date", field: "date_kpi", 
                      render: rowData => <div style = {{width: "90px"}} >{rowData.date_kpi.slice(0, 10)}</div>
                    },
                    { title: "CS Erlangs", field: "cs_erlangs", type: "numeric" },
                    { title: "Call Setup Success Rate (%)", field: "call_setup_success_rate", type: "numeric" },
                    { title: "Call Success Rate (%)", field: "call_success_rate", type: "numeric" },
                    { title: "SDCCH Drop (%)", field: "sdcch_drop", type: "numeric" },
                    { title: "TCH Drop Rate (%)", field: "tch_drop_rate", type: "numeric" },
                    { title: "SDCCH Blocking (%)", field: "sdcch_blocking", type: "numeric" },
                    { title: "TCH Blocking (%)", field: "tch_blocking", type: "numeric" },
                    { title: "Immediate Assignment Success Rate (%)", field: "imm_ass_proc_succ_rate", type: "numeric" },
                    { title: "Total Number of Calls", field: "total_number_of_calls", type: "numeric" },
                    { title: "Total Voice Calls In Minutes", field: "total_voice_calls_in_min", type: "numeric" },
                    { title: "DL PS Erlangs", field: "dl_ps_erlangs", type: "numeric" },
                    { title: "UL PS Erlangs", field: "ul_ps_erlangs", type: "numeric" },
                    { title: "Total Data Calls", field: "total_data_calls", type: "numeric" },
                    { title: "Total Downlink Data in KByte", field: "total_downlink_data_kb", type: "numeric" },
                    { title: "Downlink Data Throughput in Kbps", field: "downlink_data_through_kbs", type: "numeric" },
                    { title: "TBF Assignment Success Rate (%)", field: "tbf_assignment_success_rate", type: "numeric" },
                    { title: "Network Availability (%)", field: "availability", type: "numeric" },
                ]}
                data={data}
            />

        </>
    )

};

export default KpiDataGrid;